import type { NavItem, Principle } from '../types/content';

export const audienceLinks: (NavItem & { audience: string })[] = [
  { audience: 'For employers', label: 'Engage us on a senior search', to: '/employers' },
  { audience: 'For candidates', label: 'Register your interest confidentially', to: '/candidates' },
  { audience: 'For boards', label: 'Board and non-executive search', to: '/leadership-board-search' },
];

export const employerBenefits: Principle[] = [
  {
    title: 'Structured executive search',
    description: 'A defined process from briefing to shortlist, with criteria agreed before outreach begins.',
  },
  {
    title: 'Targeted sourcing',
    description: 'Research focused on the organizations and individuals most relevant to your brief.',
  },
  {
    title: 'Professional engagement',
    description: 'Discreet, well-informed approaches that represent your organization accurately.',
  },
  {
    title: 'Candidate evaluation',
    description: 'Assessment against role-specific criteria, so you meet fewer, better-qualified people.',
  },
];

export const employerExpectations = {
  fromUs: [
    'A clear search plan and timeline agreed at the outset',
    'Regular progress updates and candid market feedback',
    'Confidential handling of your brief and organization',
    'Structured candidate summaries against agreed criteria',
  ],
  fromYou: [
    'Access to the people who will shape and decide the appointment',
    'Honest context on the organization, team and challenges',
    'Timely feedback on candidates and interviews',
    'Clarity on remuneration parameters and decision process',
  ],
};

export const candidateCommitments: Principle[] = [
  {
    title: 'Discreet conversations',
    description: 'We discuss any specific opportunity with you before an introduction is considered.',
  },
  {
    title: 'An accurate picture',
    description: 'We share what we know about a role and organization so you can make an informed choice.',
  },
  {
    title: 'Respect for your time',
    description: 'We contact you when your experience appears genuinely relevant to a search.',
  },
];

export const candidateDisclaimer =
  'Registering your interest does not guarantee contact about a specific role, an interview, or a placement. We will be in touch if your experience aligns with a relevant search.';
